import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {constants} from '../app-constants';
import {ClienteModel, ClienteResult, UsuarioLogadoModel} from '../model';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {

  private pathOSWS = `/WS/rest/PortalCliente`;
  private httpOptions = constants.httpDefaultOptions;

  constructor( private http: HttpClient) {
  }

  getCliente(): Observable<ClienteResult> {
    return this.http.get<ClienteResult>(`${this.pathOSWS}/Cliente/v1`, this.httpOptions);
  }
  editarDados(cliente: any): Observable<any> {
    return this.http.post<any>(`${this.pathOSWS}/EditarDados/v1`, JSON.stringify(cliente), this.httpOptions);
  }
}
